import { delayedPromise } from '@/Utils/promise-utils';
import store from '@/store/store';

/**
 * 用于数据加载的方法,使用这个装饰器会自动让方法运行时界面处于加载中状态
 */
export function DataLoad(): MethodDecorator {
    return ((target, propertyKey, descriptor: TypedPropertyDescriptor<(...args) => Promise<unknown>>) => {
        const method = descriptor.value;
        if (method == null) {
            return;
        }
        descriptor.value = async function (...args): Promise<void> {
            store.commit('setIsMainOnLoading', true);
            await method.call(this, ...args);
            store.commit('setIsMainOnLoading', false);
        };
        return descriptor;
    }) as MethodDecorator;
}
